<script>
  let { children } = $props()
</script>

<thead class="bg-gray-50/80">
  <tr class="text-smaller text-gray-500">
    {@render children?.()}
  </tr>
</thead>